'use strict';

const {datadogLogs} = require('@datadog/browser-logs');

const DataDogLogs = {
    init: function () {
        if (SitePreferences.DATA_DOG_CONFIG) {
            const {
                dataDogClientToken,
                dataDogSessionSampleRate,
                dataDogSite,
                dataDogService
            } = SitePreferences.DATA_DOG_CONFIG;

            datadogLogs.init({
                clientToken: dataDogClientToken,
                site: dataDogSite,
                forwardErrorsToLogs: true,
                service: dataDogService,
                sessionSampleRate: dataDogSessionSampleRate || 100,
            });
            console.log('radiii logs');
        } else {
            console.warn('Datadog Logs is not initialized. Missing configuration in SitePreferences.');
        }
    },
};

module.exports = DataDogLogs;
